import React__default from 'react';
import AccordionSummary from '../../../../../../node_modules/@mui/material/AccordionSummary/AccordionSummary.mjs';
import ExpandMore from '../../../../../../node_modules/@mui/icons-material/esm/ExpandMore.mjs';

const AccordionSummaryCore = (props)=>{
    return /*#__PURE__*/ React__default.createElement(AccordionSummary, {
        expandIcon: /*#__PURE__*/ React__default.createElement(ExpandMore, {
            fontSize: "large"
        }),
        ...props
    });
};

export { AccordionSummaryCore };
//# sourceMappingURL=Accordion.mjs.map
